import { config } from "@/config";
import { Amplify } from "aws-amplify";
import { I18n } from "aws-amplify/utils";
import { enAuthI18n } from "@/plugins/amplify/authI18n";

const AmplifyConfig = {
  configure: function () {
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: config.amplify.userPoolId,
          userPoolClientId: config.amplify.userPoolWebClientId,
          passwordFormat: config.amplify.passwordFormat,
        },
      },
    });

    I18n.putVocabulariesForLanguage("en", enAuthI18n);

    I18n.setLanguage("en");
  },
};

export default AmplifyConfig;
